export enum ClientTypeEnum {
    NSRU = 'NSRU',
    MULTIBAL = 'MULTIBAL',
    PARNASSE = 'PARNASSE',
    SUGGESTED = 'SUGGESTED',
    PROTECTEDHOUSE = 'PROTECTEDHOUSE',
    TERMINATED = 'TERMINATED',
    PRO = 'PRO',
    OBS = 'OBS',
    SHAREDSERVICES = 'SHAREDSERVICES',
}
